var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"audioMuted"}},[_c('div',{attrs:{"id":"audioMuteds"},on:{"click":_vm.audioMuted}},[_c('span',[_vm._v(_vm._s(_vm.$t("因浏览器限制，需手动点击打开声音")))]),_c('span',{attrs:{"id":"close"}},[_vm._v(_vm._s(_vm.$t("开启")))])])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7210e10c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 